import React, { ReactNode } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';
import '../TaskForm/usuario-form.css';
import '../TaskForm/planner-form-fields.css';
import './custom-registration-modal.css';

export interface CustomRegistrationModalShellProps {
  mode: 'add' | 'edit';
  recordId?: string;
  title: string;
  subtitle: string;
  onCancel: () => void;
  onSave: () => void;
  saveDisabled?: boolean;
  cancelDisabled?: boolean;
  children: ReactNode;
}

const CustomRegistrationModalShell = ({
  mode,
  recordId,
  title,
  subtitle,
  onCancel,
  onSave,
  saveDisabled = false,
  cancelDisabled = false,
  children,
}: CustomRegistrationModalShellProps) => {
  return (
    <div className="usuario-form custom-reg-form">
      <div className="usuario-form__header">
        <div className="usuario-form__header-left">
          <div className="usuario-form__header-text">
            <h2 className="usuario-form__title">
              {mode === 'edit' ? (
                <>
                  <span className="usuario-form__title-accent">{title}</span>
                  {recordId ? (
                    <span className="usuario-form__id-badge">ID {recordId}</span>
                  ) : null}
                </>
              ) : (
                title
              )}
            </h2>
            <p className="usuario-form__subtitle">{subtitle}</p>
          </div>
        </div>
        <div className="usuario-form__header-actions">
          <button
            type="button"
            className="usuario-form__btn usuario-form__btn--ghost"
            onClick={onCancel}
            disabled={cancelDisabled}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="usuario-form__btn usuario-form__btn--primary"
            onClick={onSave}
            disabled={saveDisabled}
          >
            <FaSave size={14} />
            Salvar Dados
          </button>
        </div>
      </div>

      <div className="usuario-form__body custom-reg-form__body">{children}</div>

      <div className="usuario-form__footer">
        <p className="usuario-form__footer-hint">
          <span className="usuario-form__footer-line" />
          Preencha os campos obrigatórios para salvar
        </p>
        <div className="usuario-form__footer-actions">
          <button
            type="button"
            className="usuario-form__btn usuario-form__btn--ghost"
            onClick={onCancel}
            disabled={cancelDisabled}
          >
            <FaTimes size={14} />
            Cancelar
          </button>
          <button
            type="button"
            className="usuario-form__btn usuario-form__btn--primary"
            onClick={onSave}
            disabled={saveDisabled}
          >
            <FaSave size={14} />
            Salvar Dados
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomRegistrationModalShell;
